module.exports = __webpack_public_path__ + "static/banner-two-shape5-36c90241ce246a7c4b01c2b2c9d79ac9.png";